//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ISelfServeGallery } from '@apis/galleries/galleriesApiModels';
import { isInstaShopGallery } from '@galleries/utils/isInstaShopGallery';
import { getAllAlphabetizedGalleries } from './getAllAlphabetizedGalleries';

export const getAllInstaShopGalleries = createSelector(
  getAllAlphabetizedGalleries,
  (galleries): ISelfServeGallery[] => {
    const instaShopGalleries: ISelfServeGallery[] = [];

    for (const gallery of galleries) {
      if (isInstaShopGallery(gallery)) {
        instaShopGalleries.push(gallery);
      }
    }

    return instaShopGalleries;
  },
);
